import apiClient from './apiClient';
import axios from 'axios';

const authService = {
  login: async (studentId, password) => {
    if (!studentId || studentId.trim() === '') {
      throw new Error('Student ID is required');
    }
    if (!password || password.trim() === '') {
      throw new Error('Password is required');
    }
    
    try {
      
      const url = `${apiClient.defaults.baseURL}/Students/login`;
      const response = await axios.post(url, { studentId, password });
      
      if (!response || !response.data) {
        throw new Error('Invalid student ID or password');
      }
      
      // New API returns { token, expiration, student: { ... } }
      const payload = response.data;
      const studentData = payload.student || payload; // backward compat if old API returns student object directly
      const token = payload.token;
      
      if (!token) {
        // Do not mark as logged in without a token; prevents redirect loops
        throw new Error('Authentication token missing. Please try again.');
      }
      localStorage.setItem('auth_token', token);
      
      localStorage.setItem('student_pk', studentData.id.toString());
      localStorage.setItem('student_id', studentData.studentId);
      localStorage.setItem('student_name', `${studentData.firstName} ${studentData.lastName}`);
      localStorage.setItem('is_logged_in', 'true');
      return studentData;
    } catch (err) {
      if (err.response) {
        if (err.response.status === 401) {
          // Check if backend sent a specific error message (e.g., account frozen/inactive)
          const errorMessage = typeof err.response.data === 'string' 
            ? err.response.data 
            : err.response.data?.message || 'Invalid student ID or password';
          throw new Error(errorMessage);
        }
        if (err.response.status === 404) {
          throw new Error('Student was not found');
        }
        throw new Error('Authentication failed. Please try again later.');
      } else if (err.request) {
        throw new Error('Could not connect to server. Please check your network connection.');
      } else {
        throw new Error('An unexpected error occurred. Please try again.');
      }
    }
  },
  
  isLoggedIn: () => {
    const token = localStorage.getItem('auth_token');
    return localStorage.getItem('is_logged_in') === 'true' && !!token;
  },
  

  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('student_pk');
    localStorage.removeItem('student_id');
    localStorage.removeItem('student_name');
    localStorage.removeItem('is_logged_in');
  },
  
  getCurrentStudent: () => {
    if (!authService.isLoggedIn()) return null;
    return {
      studentPk: localStorage.getItem('student_pk'),
      studentCode: localStorage.getItem('student_id'),
      name: localStorage.getItem('student_name')
    };
  }
};

export default authService;
